module.exports = __webpack_public_path__ + "static/media/logo-avaliare-white.9070d6a6.png";